var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from "lit";
import { customElement } from "lit/decorators.js";
import { Event } from "../models/enums.js";
import { DataStore, Router } from "../services/datastore.service.js";
import { EventBus } from "../services/eventbus.service.js";
import Utils from "../utils/utils.js";
let AppAdmin = class AppAdmin extends LitElement {
    constructor() {
        super();
        this.list = [];
        this.content = "";
        this.tab = "info";
        this.datastore = DataStore.getInstance();
        this.eventbus = EventBus.getInstance();
    }
    connectedCallback() {
        super.connectedCallback();
        if (!this.datastore.isAdmin) {
            Router.go("/404");
            return;
        }
        this.eventbus.addEventListener(Event.RequestUpdate, (_event) => {
            this.requestUpdate();
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    createRenderRoot() {
        return this;
    }
    firstUpdated() {
        if (this.datastore.isAdmin) {
            this.fetchData();
        }
    }
    tokenInfo() {
        const now = new Date();
        const accessToken = Utils.parseJwt(this.datastore.token.access_token);
        const accessDiff = (Utils.numberToDate(accessToken.exp).getTime() - now.getTime()) / 1000;
        const refreshToken = Utils.parseJwt(this.datastore.token.refresh_token);
        const refreshDiff = (Utils.numberToDate(refreshToken.exp).getTime() - now.getTime()) / 1000;
        return html `
            Accesstoken expires in ${accessDiff} seconds<br>
            Refreshtoken expires in ${refreshDiff} seconds
        `;
    }
    setTab(tab) {
        this.tab = tab;
        this.requestUpdate();
    }
    fetchData() {
        this.datastore
            .fetchContentList()
            .then((list) => {
            this.list = list;
            this.requestUpdate();
        })
            .catch((error) => {
            this.requestUpdate();
            this.eventbus.dispatchError(error);
        });
    }
    updateContentText() {
        const title = document.getElementById("select-title").value;
        const c = this.list.find((content) => content.title === title);
        this.content = c.text;
        this.requestUpdate();
    }
    saveContentText() {
        const title = document.getElementById("select-title").value;
        const text = document.getElementById("contentText").value;
        const content = { title: title, text: text };
        this.datastore
            .updateContent(content)
            .then((_) => {
            this.eventbus.dispatchEvent(Event.Toast, {
                text: "Content saved",
                classes: "fas fa-file",
                type: "is-info",
            });
        })
            .finally(() => {
            this.fetchData();
        });
    }
    sendWebpush() {
        const title = document.getElementById("title").value;
        const clickTarget = document.getElementById("clickTarget").value;
        const message = document.getElementById("message").value;
        const webpush = { title: title, clickTarget: clickTarget, message: message };
        this.datastore
            .webpushSend(webpush)
            .then((_) => { });
    }
    render() {
        return html `
      <div class="box">
        <div class="tabs">
          <ul>
            <li class="${this.tab === "info" ? "is-active" : ""}">
              <a @click="${() => this.setTab("info")}">
                <span class="icon is-small"><i class="fas fa-info" aria-hidden="true"></i></span>
                <span>Info</span>
              </a>
            </li>
            <li class="${this.tab === "content" ? "is-active" : ""}">
              <a @click="${() => this.setTab("content")}">
                <span class="icon is-small"><i class="fas fa-keyboard" aria-hidden="true"></i></span>
                <span>Content</span>
              </a>
            </li>
            <li class="${this.tab === "webpush" ? "is-active" : ""}">
              <a @click="${() => this.setTab("webpush")}">
                <span class="icon is-small"><i class="fas fa-comment" aria-hidden="true"></i></span>
                <span>Webpush</span>
              </a>
            </li>
            <li class="${this.tab === "log" ? "is-active" : ""}">
              <a @click="${() => this.setTab("log")}">
                <span class="icon is-small"><i class="fas fa-list-alt" aria-hidden="true"></i></span>
                <span>Log</span>
              </a>
            </li>
          </ul>
        </div>

        <div class="${this.tab === "info" ? "" : "is-hidden"}">
            Source:<br>
            ${this.datastore.source}<br><br>
            Token:<br>
            ${this.tokenInfo()}<br><br>
        </div>

        <div class="${this.tab === "content" ? "" : "is-hidden"}">
          <div class="field">
            <div class="control">
              <div class="select">
                <select id="select-title" @change=${() => this.updateContentText()}>
                  <option value=""></option>
                  ${this.list?.map((content) => html `<option value="${content.title}">${content.title}</option>`)}
                </select>
              </div>
            </div>
          </div>
          <div class="field">
            <div class="control">
              <textarea id="contentText" class="textarea" type="text" rows="30" .value="${this.content}"></textarea>
            </div>
          </div>
          <div class="buttons is-centered">
            <button class="button is-link is-rounded" @click="${() => this.saveContentText()}">
              <span class="icon">
                <i class="fas fa-save"></i>
              </span>
            </button>
          </div>
        </div>

        <div class="${this.tab === "webpush" ? "" : "is-hidden"}">
            <div class="field">
                <p class="control has-icons-left">
                    <input id="title" class="input" type="text" placeholder="Title" />
                    <span class="icon is-left">
                        <i class="fas fa-heading"></i>
                    </span>
                </p>
            </div>
            <div class="field">
                <p class="control has-icons-left">
                    <input id="clickTarget" class="input" type="text" placeholder="Clicktarget" />
                    <span class="icon is-left">
                        <i class="fas fa-link"></i>
                    </span>
                </p>
            </div>
            <div class="field">
                <div class="control">
                    <textarea id="message" class="textarea" type="text" rows="5"></textarea>
                </div>
            </div>
            <div class="buttons is-centered">
                <button class="button is-link is-rounded" @click="${() => this.sendWebpush()}">
                    <span class="icon">
                        <i class="fas fa-share"></i>
                    </span>
                </button>
            </div>
        </div>

        <div class="${this.tab === "log" ? "" : "is-hidden"}">
          <table class="table is-fullwidth">
            ${this.datastore.logs.map((entry) => html `
            <tr>
                <td>${entry}</td>
            </tr>
            `)}
          </table>
        </div>
      </div>
    `;
    }
};
AppAdmin = __decorate([
    customElement("app-admin")
], AppAdmin);
export { AppAdmin };
//# sourceMappingURL=admin.js.map